import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios'

import { userVerify, userVerifyLineCheck } from '../redux/actions'

class LoginverifyLine extends Component {

    constructor() {
        super()
        this.state = {
            userid: "",
            user: null
        }
    }

    getParams(location) {
        const searchParams = new URLSearchParams(location.search);
        return {
          code: searchParams.get('code') || '',
          state: searchParams.get('state') || ''
        };
    }
    
    componentDidMount() {
        const params = this.getParams(window.location)
        if(params.code) {
          const data = {
            grant_type: "authorization_code",
            code: params.code,
            redirect_uri: "https://aps-cooling.firebaseapp.com/loginverifyline",
            client_id: process.env.REACT_APP_LINE_CHANNEL_ID,
            client_secret: process.env.REACT_APP_LINE_CHANNEL_SECRET
          }
      
          // query string
          const query = Object.keys(data).map(function(key) {
              return encodeURIComponent(key) + '=' + encodeURIComponent(data[key])
          }).join('&')
      
          const self = this
          axios.post('https://api.line.me/oauth2/v2.1/token', query, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          })
          .then(function (response) {
            console.log("LINE token success", response);
            const AuthStr = 'Bearer '.concat(response.data.access_token);
      
            axios.get("https://api.line.me/v2/profile", { headers: { Authorization: AuthStr }})
            .then(res => {
                self.setState({user: res.data})
                self.checkSocial(res.data.userId)
                // self.props.loginSocialCheck(res.data.userId)
            }).catch(err => console.log("LINE Info Fail", err))
      
          })
          .catch(function (error) {
            console.log("LINE token Fail", error, data);
          });
        } else {
            window.location = "/"
        }
        
    }

    checkSocial(lineId) {
        this.props.userVerifyLineCheck(lineId, "line_id")
    }

    _onHandleChange(event) {
		this.setState({
	    	[event.target.name]: event.target.value
	    });
    }
    
    _onSubmit() {
        if(this.state.userid) {
            const data = {
                id: this.state.user.userId,
                pic: this.state.user.pictureUrl,
                status: 1
            }
            this.props.userVerify(data, this.state.userid, "line_id")
        } else {
            alert("Please fill in a form...")
        }
    }

    render() { 
        return ( 
            <div className="page_login">
                <div className="container">
                    <div className="section-logo">
                        <img src={require("../static/images/01_login/logo.png")} alt="apslogo"/>
                    </div>
                    {(this.props.loadingSocial)? "Loading...":
                        <div className="section-social-login">
                            <input type="text" name="userid" onChange={(event) => this._onHandleChange(event)} placeholder="USER ID" />
                            <button onClick={()=>this._onSubmit()}>ยืนยัน</button>
                        </div>
                    }
                    
                </div>
            </div>
        )
    }
}

const mapStateToProps = ({ user }) => {
	return {
		loadingSocial: user.loadingSocial
	};
}

export default connect(mapStateToProps, { 
    userVerify, userVerifyLineCheck
})(LoginverifyLine)
